import { render, staticRenderFns } from "./PaymentPageNew.vue?vue&type=template&id=337758c7"
import script from "./PaymentPageNew.vue?vue&type=script&lang=js"
export * from "./PaymentPageNew.vue?vue&type=script&lang=js"
import style0 from "./PaymentPageNew.vue?vue&type=style&index=0&id=337758c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports